export const COGNITO_USER_POOL_ID = process.env.REACT_APP_COGNITO_USER_POOL_ID;
export const COGNITO_CLIENT_ID = process.env.REACT_APP_COGNITO_CLIENT_ID;
export const COGNITO_PICKING_USER_POOL_ID = process.env.REACT_APP_COGNITO_PICKING_USER_POOL_ID;
export const COGNITO_PICKING_CLIENT_ID = process.env.REACT_APP_COGNITO_PICKING_CLIENT_ID;

